import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import brand1 from "src/Logo/homelys_logo.png";
import brand2 from "src/Logo/HOMELY_PROPERTIES.png";

const brands = [
  { name: "Homely", logo: brand1 },
  { name: "Homely Properties", logo: brand2 },
];

const OurBrand = () => (
  <Box
    component="section"
    sx={{
      px: { xs: 3, md: 8 },
      py: { xs: 7, md: 10 },
      backgroundColor: "#f6f4ef",
      textAlign: "center",
    }}
  >
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <Typography
        component="p"
        sx={{
          mb: 1.5,
          color: "#9a794b",
          fontSize: "0.68rem",
          fontWeight: 600,
          letterSpacing: "0.2em",
        }}
      >
        OUR FAMILY
      </Typography>
      <Typography
        component="h2"
        variant="h3"
        sx={{ mb: { xs: 4, md: 5 }, fontSize: { xs: "2.2rem", md: "3rem" } }}
      >
        Our brands
      </Typography>
    </motion.div>

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
        gap: { xs: 2, md: 4 },
        maxWidth: 980,
        mx: "auto",
      }}
    >
      {brands.map((brand, index) => (
        <motion.div
          key={brand.name}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{
            duration: 0.65,
            ease: [0.22, 1, 0.36, 1],
            delay: index * 0.14,
          }}
          whileHover={{ y: -5 }}
        >
          <Box
            sx={{
              minHeight: { xs: 150, md: 190 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: { xs: 3, md: 4 },
              backgroundColor: "#eeece5",
              transition: "box-shadow 250ms ease",
              "&:hover": {
                boxShadow: "0 18px 38px rgba(41, 39, 32, 0.08)",
              },
            }}
          >
            <Box
              sx={{
                width: "min(100%, 340px)",
                aspectRatio: "3 / 1",
                overflow: "hidden",
              }}
            >
              <Box
                component="img"
                src={brand.logo}
                alt={brand.name}
                loading="lazy"
                sx={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Box>
        </motion.div>
      ))}
    </Box>
  </Box>
);

export default OurBrand;
